// import Queue from "nq";

// class SaveFileUseCase {
//   execute(blob, session) {
//     console.log("blob", blob);
//     return Queue.File.save(blob, session);
//   }
// }

// export default SaveFileUseCase;

import Queue from "nq";

class SaveFileUseCase {
  execute(blob, session) {
    const file = new Queue.File(); // instantiate
    return file.save(blob, session); // call instance method
  }
}

export default SaveFileUseCase;
